export class AssetPhotoDto {
    public Id: number
    public Description: string
    public CreatedBy: string
    public CreatedOn?: Date
}